<template>
  <div class="picto-wrapper tw-relative tw-flex tw-items-end tw-justify-center">
    <div class="tw-absolute tw-flex tw-h-full tw-w-full tw-flex-col">
      <svg class="tw-flex-initial" width="100%" viewBox="0 0 256 118" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0 117.79C0 111.162 5.37258 105.79 12 105.79H244C250.627 105.79 256 111.162 256 117.79V322.221C256 328.848 250.627 334.221 244 334.221H12C5.37258 334.221 0 328.848 0 322.221V117.79Z"
          fill="#F2F2F6"
        />
        <path
          d="M34 137V73C34 35.9344 75.9118 18 129 18C182.088 18 224 35.9344 224 73C224 73 224 76.3285 224 84.3279"
          stroke="#F2F2F6"
          stroke-width="36"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <svg
        class="tw-flex-1"
        width="100%"
        preserveAspectRatio="none"
        viewBox="0 0 256 126"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 -76.877H256V139.554C256 146.181 250.627 151.554 244 151.554H12C5.37258 151.554 0 146.181 0 139.554V-76.877Z"
          fill="#F2F2F6"
        />
      </svg>
      <svg class="tw-flex-initial" width="100%" viewBox="0 0 256 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0 -216.877H256V-0.446193C256 6.18122 250.627 11.5538 244 11.5538H12C5.37258 11.5538 0 6.18123 0 -0.446182V-216.877Z"
          fill="#F2F2F6"
        />
      </svg>
    </div>
    <div class="tw-z-[1]">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped>
.picto-wrapper {
  transition: width 250ms, height 250ms;
}
</style>
